// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-us-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle at top left, rgba(245, 162, 93, 0.28) 0%, rgba(245, 162, 93, 0) 28%), radial-gradient(circle at 88% 14%, rgba(72, 136, 222, 0.18) 0%, rgba(72, 136, 222, 0) 24%), linear-gradient(180deg, #fff7ec 0%, #f6f3ef 38%, #e7edf4 100%);
  padding: 24px 18px 48px;
  box-sizing: border-box;
}

.about-us-shell {
  position: relative;
  z-index: 1;
  max-width: 960px;
  margin: 0 auto;
}

.about-us-top-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 18px;
}

.about-us-top-button {
  border: 0;
  border-radius: 999px;
  padding: 12px 16px;
  cursor: pointer;
  background: linear-gradient(135deg, #193e6d 0%, #2c73c6 100%);
  color: #fff9f0;
  font: 700 0.9rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  box-shadow: 0 12px 28px rgba(22, 53, 92, 0.18);
}

.about-us-top-button-secondary {
  background: rgba(255, 255, 255, 0.78);
  color: #163355;
}

.about-us-hero,
.about-us-content {
  position: relative;
  overflow: hidden;
  border-radius: 34px;
  box-shadow: 0 28px 58px rgba(18, 31, 51, 0.15);
}

.about-us-hero {
  margin-bottom: 22px;
  padding: 30px 26px;
  color: #fffaf2;
  background: radial-gradient(circle at top right, rgba(253, 209, 151, 0.22) 0%, rgba(253, 209, 151, 0) 30%), linear-gradient(145deg, rgba(13, 24, 41, 0.98) 0%, rgba(24, 54, 90, 0.95) 58%, rgba(182, 93, 38, 0.86) 100%);
}

.about-us-kicker {
  display: inline-flex;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #ffe7c9;
  font: 700 0.76rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.about-us-hero h1 {
  margin: 0 0 14px;
  font: 800 clamp(2.4rem, 6vw, 4.2rem)/0.96 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: -0.06em;
}

.about-us-hero p {
  max-width: 720px;
  margin: 0;
  color: rgba(255, 250, 242, 0.86);
  font: 500 1rem/1.7 "Trebuchet MS", "Gill Sans", sans-serif;
}

.about-us-content {
  display: grid;
  gap: 18px;
  padding: 28px 24px;
  background: rgba(255, 255, 255, 0.84);
  backdrop-filter: blur(12px);
}

.about-us-content p {
  margin: 0;
  color: #19314f;
  font: 500 1rem/1.8 "Trebuchet MS", "Gill Sans", sans-serif;
}

.about-us-footer {
  display: grid;
  justify-items: center;
  gap: 10px;
  padding: 28px 0 8px;
  text-align: center;
}

.about-us-footer p {
  margin: 0;
  color: #17314f;
  font: 700 0.95rem/1.4 "Trebuchet MS", "Gill Sans", sans-serif;
}

.about-us-footer-link {
  border: 0;
  padding: 0;
  background: transparent;
  color: #1f5ea8;
  cursor: pointer;
  font: 700 0.98rem/1.4 "Trebuchet MS", "Gill Sans", sans-serif;
  text-decoration: underline;
}

.about-us-glow {
  position: absolute;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  filter: blur(22px);
  opacity: 0.4;
}

.about-us-glow-left {
  left: -80px;
  top: 40px;
  background: rgba(242, 166, 105, 0.5);
}

.about-us-glow-right {
  right: -90px;
  bottom: 60px;
  background: rgba(62, 146, 196, 0.34);
}

@media (min-width: 768px) {
  .about-us-page {
    padding: 38px 24px 56px;
  }
  .about-us-hero {
    padding: 38px 34px;
  }
  .about-us-content {
    padding: 34px 32px;
  }
  .about-us-footer {
    padding-top: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/home/AboutUsPage.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mQACE;EAGF,uBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AAFF;;AAKA;EACE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,6DAAA;EACA,cAAA;EACA,0DAAA;EACA,8CAAA;AAFF;;AAKA;EACE,qCAAA;EACA,cAAA;AAFF;;AAKA;;EAEE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8CAAA;AAFF;;AAKA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,wNACE;AAHJ;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qCAAA;EACA,cAAA;EACA,2DAAA;EACA,sBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,iFAAA;EACA,uBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,SAAA;EACA,gCAAA;EACA,0DAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,qCAAA;EACA,2BAAA;AAJF;;AAOA;EACE,SAAA;EACA,cAAA;EACA,0DAAA;AAJF;;AAOA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,SAAA;EACA,cAAA;EACA,6DAAA;AAJF;;AAOA;EACE,SAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,6DAAA;EACA,0BAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;EACA,SAAA;EACA,oCAAA;AAJF;;AAOA;EACE,YAAA;EACA,YAAA;EACA,oCAAA;AAJF;;AAOA;EACE;IACE,uBAAA;EAJF;EAOA;IACE,kBAAA;EALF;EAQA;IACE,kBAAA;EANF;EASA;IACE,iBAAA;EAPF;AACF","sourcesContent":[".about-us-page {\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at top left, rgba(245, 162, 93, 0.28) 0%, rgba(245, 162, 93, 0) 28%),\n    radial-gradient(circle at 88% 14%, rgba(72, 136, 222, 0.18) 0%, rgba(72, 136, 222, 0) 24%),\n    linear-gradient(180deg, #fff7ec 0%, #f6f3ef 38%, #e7edf4 100%);\n  padding: 24px 18px 48px;\n  box-sizing: border-box;\n}\n\n.about-us-shell {\n  position: relative;\n  z-index: 1;\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.about-us-top-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.about-us-top-button {\n  border: 0;\n  border-radius: 999px;\n  padding: 12px 16px;\n  cursor: pointer;\n  background: linear-gradient(135deg, #193e6d 0%, #2c73c6 100%);\n  color: #fff9f0;\n  font: 700 0.9rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  box-shadow: 0 12px 28px rgba(22, 53, 92, 0.18);\n}\n\n.about-us-top-button-secondary {\n  background: rgba(255, 255, 255, 0.78);\n  color: #163355;\n}\n\n.about-us-hero,\n.about-us-content {\n  position: relative;\n  overflow: hidden;\n  border-radius: 34px;\n  box-shadow: 0 28px 58px rgba(18, 31, 51, 0.15);\n}\n\n.about-us-hero {\n  margin-bottom: 22px;\n  padding: 30px 26px;\n  color: #fffaf2;\n  background:\n    radial-gradient(circle at top right, rgba(253, 209, 151, 0.22) 0%, rgba(253, 209, 151, 0) 30%),\n    linear-gradient(145deg, rgba(13, 24, 41, 0.98) 0%, rgba(24, 54, 90, 0.95) 58%, rgba(182, 93, 38, 0.86) 100%);\n}\n\n.about-us-kicker {\n  display: inline-flex;\n  margin-bottom: 16px;\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffe7c9;\n  font: 700 0.76rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.about-us-hero h1 {\n  margin: 0 0 14px;\n  font: 800 clamp(2.4rem, 6vw, 4.2rem)/0.96 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: -0.06em;\n}\n\n.about-us-hero p {\n  max-width: 720px;\n  margin: 0;\n  color: rgba(255, 250, 242, 0.86);\n  font: 500 1rem/1.7 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.about-us-content {\n  display: grid;\n  gap: 18px;\n  padding: 28px 24px;\n  background: rgba(255, 255, 255, 0.84);\n  backdrop-filter: blur(12px);\n}\n\n.about-us-content p {\n  margin: 0;\n  color: #19314f;\n  font: 500 1rem/1.8 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.about-us-footer {\n  display: grid;\n  justify-items: center;\n  gap: 10px;\n  padding: 28px 0 8px;\n  text-align: center;\n}\n\n.about-us-footer p {\n  margin: 0;\n  color: #17314f;\n  font: 700 0.95rem/1.4 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.about-us-footer-link {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: #1f5ea8;\n  cursor: pointer;\n  font: 700 0.98rem/1.4 'Trebuchet MS', 'Gill Sans', sans-serif;\n  text-decoration: underline;\n}\n\n.about-us-glow {\n  position: absolute;\n  width: 240px;\n  height: 240px;\n  border-radius: 50%;\n  filter: blur(22px);\n  opacity: 0.4;\n}\n\n.about-us-glow-left {\n  left: -80px;\n  top: 40px;\n  background: rgba(242, 166, 105, 0.5);\n}\n\n.about-us-glow-right {\n  right: -90px;\n  bottom: 60px;\n  background: rgba(62, 146, 196, 0.34);\n}\n\n@media (min-width: 768px) {\n  .about-us-page {\n    padding: 38px 24px 56px;\n  }\n\n  .about-us-hero {\n    padding: 38px 34px;\n  }\n\n  .about-us-content {\n    padding: 34px 32px;\n  }\n\n  .about-us-footer {\n    padding-top: 32px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
